export default {
  'menu': {
    'form_parent': 'Parent',
    'form_parent_select': 'Please select',
    'form_close_select': 'Close',
    'form_fast_select': 'Select',
    'form_select_rules': 'select rules',
    'form_title': 'Title',
    'form_enter_title': 'enter title',
    'form_slug': 'Slug',
    'form_enter_slug': 'enter slug',
    'form_url': 'Url',
    'form_url_tooltip': 'url has prefix',
    'form_enter_url': 'enter url',
    'form_method': 'Method',
    'form_sort': 'Sort',
    'form_enter_sort': 'enter sort',
    'form_save': 'Save',
    'form_clear': 'Reset',
    'form_top_menu': 'top menu',
    'form_create_success': 'Create success',
    'form_update_success': 'Update success',

    'rules_pid_required': 'parent required',
    'rules_title_required': 'title required',
    'rules_slug_required': 'slug required',
    'rules_url_required': 'url required',
    'rules_sort_required': 'sort required',

    'search_title': 'Menus',
    'search_alert_title': 'menu set tip',
    'search_alert_description': 'now, menu not use',
    'search_create': 'Add',

    'table_title': 'Menu',
    'table_url': 'Url',
    'table_sort': 'Sort',
    'table_actions': 'Actions',
    'table_detail': 'Detail',
    'table_update': 'Update',
    'table_delete': 'Delete',

    'dialog_create': 'Create',
    'dialog_update': 'Update',
    'dialog_detail': 'Detail',

    'detail_id': 'ID',
    'detail_parentid': 'Parent',
    'detail_title': 'Title',
    'detail_slug': 'Slug',
    'detail_url': 'Url',
    'detail_method': 'Method',
    'detail_sort': 'Sort',

    'confirm_delete': 'confirm delete the menu?',
    'confirm_delete_success': 'delete the menu success'
  }

}
